<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<div class="p-4">
    <p class="mb-0">{{message}}</p>
</div>
<div class="modal-footer">
    <button class="btn btn-default" type="button" (click)="cancel()">OK</button>
</div>